import Icon from "../icons/Icon";

// Circular icon-only button. `label` is required: it becomes the accessible
// name and the tooltip.
export default function IconButton({
  icon,
  label,
  size = "md",
  variant = "tertiary",
  active = false,
  as: Component = "button",
  className = "",
  ...rest
}) {
  const classes = [
    "rl-icon-btn",
    size === "sm" ? "rl-icon-btn--sm" : "",
    variant === "primary" ? "rl-icon-btn--primary" : "",
    active ? "rl-icon-btn--active" : "",
    className,
  ].filter(Boolean).join(" ");
  const extra = Component === "button" ? { type: "button" } : {};
  return (
    <Component className={classes} aria-label={label} title={label} {...extra} {...rest}>
      <Icon name={icon} size={size === "sm" ? 16 : 20} />
    </Component>
  );
}
